import { Controller } from "@hotwired/stimulus";

// Connects to data-controller='categories--admin--review-gifts--error-modal'
export default class extends Controller {
  static targets = ["submitButton"];

  updateSubmitButton(event) {
    if (event.target.checked && event.target.value === "create_new") {
      this.submitButtonTarget.value = event.params.label || "Save & Next";
    } else {
      this.submitButtonTarget.value = "Update Record";
    }
  }
}
